import React from "react";

export const Marquee = () => {
  const items = [
    "HERO OF THE STREETS",
    "PRIDE OF THE NATION",
    "100% NAIJA PRIDE",
    "NIGERIA MADE",
    "THE GREEN SURGE",
    "NO ONE LEFT BEHIND",
  ];
  const loop = [...items, ...items];
  return (
    <div className="relative bg-emerald-500 py-3 overflow-hidden border-y-4 border-black" data-testid="marquee">
      <div className="marquee-track items-center gap-8">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-8 shrink-0">
            <span className="font-display text-2xl sm:text-3xl text-emerald-950 whitespace-nowrap tracking-wide">{t}</span>
            <span className="text-amber-600 text-2xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
